import {
  Section,
  SectionFilterFilterType,
  SectionIndustryInfo,
  SectionTable
} from './types';

export enum SectionActionTypeName {
  FETCH_ALL_REQUEST = '@@section/FETCH_ALL_REQUEST',
  FETCH_ALL_SUCCESS = '@@section/FETCH_ALL_SUCCESS',
  FETCH_ALL_FAIL = '@@section/FETCH_ALL_FAIL',
  ADD_SECTION_REQUEST = '@@section/ADD_SECTION_REQUEST',
  ADD_SECTION_SUCCESS = '@@section/ADD_SECTION_SUCCESS',
  ADD_SECTION_FAIL = '@@section/ADD_SECTION_FAIL',
  EDIT_SECTION_REQUEST = '@@section/EDIT_SECTION_REQUEST',
  EDIT_SECTION_SUCCESS = '@@section/EDIT_SECTION_SUCCESS',
  EDIT_SECTION_FAIL = '@@section/EDIT_SECTION_FAIL',
  DELETE_SECTION_REQUEST = '@@section/DELETE_SECTION_REQUEST',
  DELETE_SECTION_SUCCESS = '@@section/DELETE_SECTION_SUCCESS',
  DELETE_SECTION_FAIL = '@@section/DELETE_SECTION_FAIL',
  FETCH_SECTION_DETAIL_REQUEST = '@@section/FETCH_SECTION_DETAIL_REQUEST',
  FETCH_SECTION_DETAIL_SUCCESS = '@@section/FETCH_SECTION_DETAIL_SUCCESS',
  FETCH_SECTION_DETAIL_FAIL = '@@section/FETCH_SECTION_DETAIL_FAIL',
  UPDATE_SECTION_DETAIL_REQUEST = '@@section/UPDATE_SECTION_DETAIL_REQUEST',
  UPDATE_SECTION_DETAIL_SUCCESS = '@@section/UPDATE_SECTION_DETAIL_SUCCESS',
  UPDATE_SECTION_DETAIL_FAIL = '@@section/UPDATE_SECTION_DETAIL_FAIL',
}

interface IBaseSectionAction {
  loading: boolean;
}

interface IGetSectionsActionRequest extends IBaseSectionAction {
  type: typeof SectionActionTypeName.FETCH_ALL_REQUEST;
}

interface IGetSectionsActionSuccess extends IBaseSectionAction {
  type: typeof SectionActionTypeName.FETCH_ALL_SUCCESS;
  filterType: SectionFilterFilterType[];
  sections: SectionTable[];
  industryInfo: SectionIndustryInfo[];
}
interface IGetSectionsActionFail extends IBaseSectionAction {
  type: typeof SectionActionTypeName.FETCH_ALL_FAIL;
}

interface IAddSectionRequest extends IBaseSectionAction {
  type: typeof SectionActionTypeName.ADD_SECTION_REQUEST;
}
interface IAddSectionSuccess extends IBaseSectionAction {
  type: typeof SectionActionTypeName.ADD_SECTION_SUCCESS;
}
interface IAddSectionFail extends IBaseSectionAction {
  type: typeof SectionActionTypeName.ADD_SECTION_FAIL;
}
interface IDeleteSectionRequest extends IBaseSectionAction {
  type: typeof SectionActionTypeName.DELETE_SECTION_REQUEST;
}
interface IDeleteSectionSuccess extends IBaseSectionAction {
  type: typeof SectionActionTypeName.DELETE_SECTION_SUCCESS;
  status: number;
  message: string;
  commited: boolean;
}
interface IDeleteSectionFail extends IBaseSectionAction {
  type: typeof SectionActionTypeName.DELETE_SECTION_FAIL;
  status: number;
}

interface IFetchSectionRequest extends IBaseSectionAction {
  type: typeof SectionActionTypeName.FETCH_SECTION_DETAIL_REQUEST;
}
interface IFetchSectionSuccess extends IBaseSectionAction {
  type: typeof SectionActionTypeName.FETCH_SECTION_DETAIL_SUCCESS;
  section: Section;
}
interface IFetchSectionFail extends IBaseSectionAction {
  type: typeof SectionActionTypeName.FETCH_SECTION_DETAIL_FAIL;
}

interface IUpdateSectionRequest extends IBaseSectionAction {
  type: typeof SectionActionTypeName.UPDATE_SECTION_DETAIL_REQUEST;
}
interface IUpdateSectionSuccess extends IBaseSectionAction {
  type: typeof SectionActionTypeName.UPDATE_SECTION_DETAIL_SUCCESS;
  status: number;
  message: string;
  commited: boolean;
}
interface IUpdateSectionFail extends IBaseSectionAction {
  type: typeof SectionActionTypeName.UPDATE_SECTION_DETAIL_FAIL;
  status: number;
  message: string;
}

export type SectionActionTypes =
  | IGetSectionsActionRequest
  | IGetSectionsActionSuccess
  | IGetSectionsActionFail
  | IAddSectionRequest
  | IAddSectionSuccess
  | IAddSectionFail
  | IFetchSectionRequest
  | IFetchSectionSuccess
  | IFetchSectionFail
  | IDeleteSectionRequest
  | IDeleteSectionSuccess
  | IDeleteSectionFail
  | IUpdateSectionRequest
  | IUpdateSectionSuccess
  | IUpdateSectionFail;
